import { QueryClientProvider } from "@tanstack/react-query";
import { Provider } from "react-redux";
import { Route, BrowserRouter as Router, Routes } from "react-router-dom";
import { AuthProvider, Login, ProtectedRoute } from "./auth";
import { ErrorBoundary, Layout } from "./components";
import { Toaster } from "./components/ui/ui/toaster";
import { AntecipationVisualization } from "./features/antecipation";
import EntregoBaixaResolution from "./features/baixa-resolution/pages/entrego-baixa-resolution";
import ImileBaixaResolution from "./features/baixa-resolution/pages/imile-baixa-resolution";
import FundBaixaResolution from "./features/baixa-resolution/pages/fund-baixa-resolution";
import EntregoCheckoutResolution from "./features/checkout/pages/entrego-resolution";
import ImileCheckoutResolution from "./features/checkout/pages/imile-resolution";
import IndriveCheckoutResolution from "./features/checkout/pages/indrive-resolution";
import GestorCheckoutResolution from "./features/checkout/pages/resolution";
import { CompanyRegistration } from "./features/company-management";
import { DocumentApproval, DocumentEdit } from "./features/document-management";
import { ControleNFSPage, SaldoConsulta, CreditoAdhocPage } from "./features/entrego";
import { ImileCadastroFranquias, ImileFechamentoPage } from "./features/imile";
import GestorLiquidacao from "./features/liquidation";
import { OfferTrackingPage } from "./features/offer-tracking";
import { SuportePage } from "./features/suporte";
import { OpsMetricsPage } from "./features/metrics";
import {
  NotaPromissoriaControlePage,
  NotaPromissoriaCriarPage,
} from "./features/nota-promissoria";
import GestorErrorPix from "./features/liquidation/pages/error-pix";
import GestorPaymentRequest from "./features/liquidation/pages/payment-request";
import { UploadPage } from "./features/upload";
import UserManagementPage from "./features/user-management/pages/user-management-page";
import RoleManagementPage from "./features/role-management/pages/role-management-page";
import OperationsManagementPage from "./features/operations-management/pages/operations-management-page";
import GestorWhatsapp from "./features/whatsapp";
import { XupinhadorPage } from "./features/xupinhador";
import { queryClient } from "./lib/queryClient";
import { Home } from "./pages/Home";
import { Unauthorized } from "./pages/Unauthorized";
import { store } from "./store";

function App() {
  return (
    <ErrorBoundary>
      <QueryClientProvider client={queryClient}>
        <Provider store={store}>
          <Router>
            <AuthProvider>
              <Routes>
                <Route path="/login" element={<Login />} />
                <Route path="/unauthorized" element={<Unauthorized />} />
                <Route
                  path="/*"
                  element={
                    <ProtectedRoute>
                      <Layout>
                        <Routes>
                          <Route path="/" element={<Home />} />

                          <Route
                            path="/liquidacao/transfeera"
                            element={<GestorLiquidacao />}
                          />
                          <Route
                            path="/liquidacao/payment-request"
                            element={<GestorPaymentRequest />}
                          />
                          <Route
                            path="/liquidacao/error-pix"
                            element={<GestorErrorPix />}
                          />
                          <Route
                            path="/checkout-resolution"
                            element={<GestorCheckoutResolution />}
                          />
                          <Route
                            path="/checkout-resolution/:ops"
                            element={<GestorCheckoutResolution />}
                          />
                          <Route
                            path="/entrego/checkout-resolution"
                            element={<EntregoCheckoutResolution />}
                          />
                          <Route
                            path="/indrive/checkout-resolution"
                            element={<IndriveCheckoutResolution />}
                          />
                          <Route
                            path="/indrive/upload-bonus"
                            element={
                              <UploadPage
                                key="indriveBonus"
                                title="InDrive Bônus Upload"
                                subtitle="Arquivo de bônus de InDrive"
                                docType="indrive_bonus_pedidos"
                                extensionFile=".csv"
                                uploadTitle="Upload Bonus InDrive"
                              />
                            }
                          />
                          <Route
                            path="/baixa-gestor"
                            element={<FundBaixaResolution />}
                          />

                          <Route
                            path="/documentos/aprovar"
                            element={<DocumentApproval />}
                          />

                          <Route
                            path="/documentos/editar"
                            element={<DocumentEdit />}
                          />

                          <Route
                            path="/entrego/cadastro-franquias"
                            element={<CompanyRegistration />}
                          />

                          <Route
                            path="/entrego/saldo-consulta"
                            element={<SaldoConsulta />}
                          />

                          <Route
                            path="/entrego/controle-nfs"
                            element={<ControleNFSPage />}
                          />

                          <Route
                            path="/entrego/credito-adhoc"
                            element={<CreditoAdhocPage />}
                          />

                          <Route
                            path="/entrego/baixa"
                            element={<EntregoBaixaResolution />}
                          />

                          <Route
                            path="/imile/cadastro-franquias"
                            element={<ImileCadastroFranquias />}
                          />

                          <Route
                            path="/imile/checkout-resolution"
                            element={<ImileCheckoutResolution />}
                          />

                          <Route
                            path="/imile/baixa"
                            element={<ImileBaixaResolution />}
                          />

                          <Route
                            path="/imile/fechamento"
                            element={<ImileFechamentoPage />}
                          />

                          <Route
                            path="/whatsapp"
                            element={<GestorWhatsapp />}
                          />

                          <Route
                            path="/suporte"
                            element={<SuportePage />}
                          />

                          <Route
                            path="/gestor/antecipacao-viz"
                            element={<AntecipationVisualization />}
                          />

                          <Route
                            path="/entrego/rastreamento-ofertas"
                            element={<OfferTrackingPage />}
                          />

                          <Route
                            path="/gestor/metricas-ops"
                            element={<OpsMetricsPage />}
                          />

                          <Route
                            path="/notas-promissorias"
                            element={<NotaPromissoriaControlePage />}
                          />

                          <Route
                            path="/notas-promissorias/criar"
                            element={<NotaPromissoriaCriarPage />}
                          />

                          <Route
                            path="/user-management"
                            element={<UserManagementPage />}
                          />

                          <Route
                            path="/role-management"
                            element={<RoleManagementPage />}
                          />

                          <Route
                            path="/operations-management"
                            element={<OperationsManagementPage />}
                          />

                          <Route
                            path="/xupinhador"
                            element={<XupinhadorPage />}
                          />
                        </Routes>
                      </Layout>
                    </ProtectedRoute>
                  }
                />
              </Routes>
            </AuthProvider>
          </Router>
        </Provider>
        <Toaster />
      </QueryClientProvider>
    </ErrorBoundary>
  );
}

export default App;
